module.exports = __webpack_public_path__ + "static/img/movie-rolling.20ecc24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/movie-rolling.svg
// module id = 1044
// module chunks = 37